import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ReviewDialog } from "@/components/ReviewDialog";

export const Reviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data.reviews)).catch(() => {});
  }, []);

  return (
    <section id="reviews" className="py-24" data-testid="reviews-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-primary mb-3">Reviews</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-semibold">What locals say</h2>
          </div>
          <ReviewDialog
            trigger={
              <Button className="rounded-full bg-primary hover:bg-[#21421D] text-white transition-colors" data-testid="leave-review-button">
                <Star className="mr-2 h-4 w-4" /> Leave a review
              </Button>
            }
          />
        </div>
        {reviews.length === 0 ? (
          <p className="text-sm text-muted-foreground" data-testid="reviews-empty">
            No reviews yet — be the first to leave one after your job.
          </p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((r, i) => (
              <div key={r.id} className="bg-white rounded-2xl border border-border p-6 animate-fade-up"
                style={{ animationDelay: `${Math.min(i * 0.06, 0.3)}s` }} data-testid={`review-card-${r.id}`}>
                <div className="flex gap-0.5 mb-3">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star key={n} className={`h-4 w-4 ${r.rating >= n ? "fill-harvest text-harvest" : "text-border"}`} />
                  ))}
                </div>
                <p className="text-sm leading-relaxed mb-4">&ldquo;{r.text}&rdquo;</p>
                <p className="text-sm font-semibold">{r.name}</p>
                {r.service_name && <p className="text-xs text-muted-foreground">{r.service_name}</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
